"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSessionMessage = void 0;
function createSessionMessage(code) {
    return [
        'ETHERspot Authentication 😎 ',
        '',
        code,
        '',
        `it will expire in less than 30 seconds`,
    ].join('\n');
}
exports.createSessionMessage = createSessionMessage;
